import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import type { WritableComputedRef } from 'vue'
import { NOOP, initAliveStoreIds, kapixContext, openUrl, remove } from 'kapix-components-vue3'
import pFormationEnteteComponentStoreCustom from './store.custom'

const storeName = 'pFormationEnteteComponent'
const customImplement: CustomStoreImplementationOptions = pFormationEnteteComponentStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function pFormationEnteteComponentFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        $parentPage: NOOP,
        $parentComponent: NOOP,
        // Constants,
        $constants: {},
        // Data,
        $data: {
          h1: undefined as Nullable<string>,
          button1: undefined as Nullable<string>,
          texte: undefined as Nullable<string>
        },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      /* @ts-ignore: to allow override in your custom file */
      $h1 (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.h1,
          set: (value) => {
            this.$data.h1 = value
            this.$emit('update:h1', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $button1 (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.button1,
          set: (value) => {
            this.$data.button1 = value
            this.$emit('update:button1', value)
          }
        })
      },
      /* @ts-ignore: to allow override in your custom file */
      $texte (): WritableComputedRef<Nullable<string>> {
        return computed({
          get: () => this.$data.texte,
          set: (value) => {
            this.$data.texte = value
            this.$emit('update:texte', value)
          }
        })
      },
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      button1Click () {
        openUrl('/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return pFormationEnteteComponentFactory(storeId)()
}

export const pFormationEnteteComponentRaw = pFormationEnteteComponentFactory()
export const pFormationEnteteComponent = () => pFormationEnteteComponentRaw() as MergeCustomStore<typeof pFormationEnteteComponentStoreCustom.instance>
